export const commentName = 'comment';
